const $ = require('./src/jquery-core');
module.exports = $;
